import { Component } from '@ecs/Component';

export class BulletTrail implements Component {
  readonly type = 'BulletTrail';

  constructor(
    public length: number = 15
  ) {}
}